export const regionaisKeys = {
  regionais: ['regionais'] as const,
  listas: () => [...regionaisKeys.regionais, 'listas'] as const,
  porEmpresa: (empresaId: string) => [...regionaisKeys.regionais, empresaId] as const,
}
